export default {
  computed: {
    reportsRoutes() {
      return {
        reports: {
          title: "Relatórios"
        },
        "reports-clients": {
          title: "Clientes"
        }
      };
    }
  }
};
